module.exports = __webpack_public_path__ + "static/media/mbsb.0f24e241.jpg";